import { post } from "../utils";
import {
  type Component,
  type ShowFormParameters,
  handlePostResult,
} from "@/global";
import { inject } from "vue";

export function useHandlePost() {
  const showParams = inject<ShowFormParameters>("showParams")!;
  const cmp = inject<Component>("component")!;
  const caller = async (api: string, data?: Record<string, any>) => {
    handlePostResult(
      await post(`${showParams.serviceType}/${api}`, {
        pageId: showParams.pageId,
        key: cmp.key,
        ...data,
      })
    );
  };

  return { caller };
}
